import {
  GET_CAMPAIGNPAGE,
  GET_DEPTSTRUCTURE,
  GET_CAMPAIGNPAGE_SUCCESS,
  GET_CAMPAIGNPAGE_FAIL,
  DELETE_CAMPAIGNPAGE,
  DELETE_CAMPAIGNPAGE_SUCCESS,
  DELETE_CAMPAIGNPAGE_FAIL,
  UPDATE_CAMPAIGNPAGE,
  UPDATE_CAMPAIGNPAGE_SUCCESS,
  UPDATE_CAMPAIGNPAGE_FAIL,
  ADD_NEW_CAMPAIGNPAGE,
  ADD_CAMPAIGNPAGE_SUCCESS,
  ADD_CAMPAIGNPAGE_FAIL,
  CAMPAIGNPAGE_LOADING,
  CAMPAIGNPAGE_RESET
} from "./actionType";

export const resetCampaignPageState = (actionType) => ({
  type: CAMPAIGNPAGE_RESET,
  payload: { actionType },
});

export const getCampaignPageSuccess = (actionType, data) => ({
  type: GET_CAMPAIGNPAGE_SUCCESS,
  payload: { actionType, data },
});

export const getCampaignPageFail = (actionType, error) => ({
  type: GET_CAMPAIGNPAGE_FAIL,
  payload: { actionType, error },
});

export const getCampaignPage = (data, path) => ({
  type: GET_CAMPAIGNPAGE,
  payload: data, path
});

// export const getDeptStructure = (data, path) => ({
//   type: GET_DEPTSTRUCTURE,
//   payload: data, path
// });

export const getCampaignPageLoading = () => ({
  type: CAMPAIGNPAGE_LOADING
});

export const deleteCampaignPage = data => ({
  type: DELETE_CAMPAIGNPAGE,
  payload: data,
});

export const deleteCampaignPageSuccess = data => ({
  type: DELETE_CAMPAIGNPAGE_SUCCESS,
  payload: data,
});

export const deleteCampaignPageFail = error => ({
  type: DELETE_CAMPAIGNPAGE_FAIL,
  payload: error,
});

export const updateCampaignPage = data => ({
  type: UPDATE_CAMPAIGNPAGE,
  payload: data,
});

export const updateCampaignPageFail = error => ({
  type: UPDATE_CAMPAIGNPAGE_FAIL,
  payload: error,
});

export const updateCampaignPageSuccess = data => ({
  type: UPDATE_CAMPAIGNPAGE_SUCCESS,
  payload: data,
});

export const addNewCampaignPage = data => ({
  type: ADD_NEW_CAMPAIGNPAGE,
  payload: data,
});

export const addCampaignPageSuccess = data => ({
  type: ADD_CAMPAIGNPAGE_SUCCESS,
  payload: data,
});

export const addCampaignPageFail = error => ({
  type: ADD_CAMPAIGNPAGE_FAIL,
  payload: error,
});